// import React, { useRef, useState } from 'react';
// import DateFormat from './DateFormat';
// import axios from 'axios';
// import { DownloadTableExcel } from 'react-export-table-to-excel';

// const ComplimentaryTable = ({ complimentary, complimentaryTotal, start, end, token, url }) => {
//     const tableRef = useRef(null);

//     const [modalVisible, setModalVisible] = useState(false);
//     const [modalData, setModalData] = useState(null);

//     const handleBillID = (idtblorderHistory) => {
//         axios.post(`${url}/billinfo_byid`, {
//             token: token,
//             bill_id: idtblorderHistory
//         })
//             .then((response) => {
//                 if (response?.data) {
//                     setModalData(response.data);
//                     setModalVisible(true);
//                 }
//             })
//             .catch((error) => {
//                 console.log(error);
//             });
//     }


//     const closeModal = () => {
//         setModalVisible(false);
//         setModalData(null);
//     }

//     return (
//         <div className="table-customer-history">
//             <DownloadTableExcel
//                 filename="customer_portal"
//                 sheet="Complimentary"
//                 currentTableRef={tableRef.current}>
//                 <button className="export">
//                     Export
//                 </button>
//             </DownloadTableExcel>
//             <div className='customer-table-title'>
//                 <h5>Complimentary List</h5>
//             </div>
//             <div className="table-history-responsive table-data-complimentary">
//                 <table className="table-complementary" ref={tableRef}>
//                     <thead>
//                         <tr className='position-sticky'>
//                             <th>Date</th>
//                             <th>Order ID</th>
//                             <th>Customer</th>
//                             <th>Total</th>
//                             <th>Mode</th>
//                         </tr>
//                     </thead>
//                     {complimentary.map((item) => (
//                         <tr key={item.idtblorderHistory}>
//                             <td><DateFormat date={item.Date} /></td>
//                             <td>
//                                 <button onClick={() => handleBillID(item.idtblorderHistory)}>
//                                     {item.idtblorderHistory}
//                                 </button>
//                             </td>
//                             <td>{item.Customer}</td>
//                             <td>{item.Total}</td>
//                             <td>{item.Mode}</td>
//                         </tr>
//                     ))}
//                     <tfoot>
//                         <tr>
//                             <td></td>
//                             <td></td>
//                             <td>Total Complimentary:</td>
//                             <td>{complimentaryTotal}</td>
//                             <td></td>
//                         </tr>
//                     </tfoot>
//                 </table>
//             </div>

//             {/* Modal for displaying the bill details */}
//             {modalVisible && modalData && (
//                 <div className="custom-modal-overlay" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
//                     <div className="custom-modal-dialog">
//                         <div className="custom-modal-content">
//                             {/* Close button (cross) */}
//                             <button type="button" className="custom-close-btn" onClick={closeModal} aria-label="Close">
//                                 &times;
//                             </button>

//                             <div className="custom-modal-header">
//                                 <h5 className="custom-modal-title" id="exampleModalLabel">Bill Details</h5>
//                                 <button type="button" className="custom-close-btn" onClick={closeModal} aria-label="Close"></button>
//                             </div>
//                             <div className="custom-modal-body">
//                                 {/* Order Summary (Top part) */}
//                                 <div className="custom-order-summary">
//                                     <div className="custom-col">
//                                         <ul className="custom-details-list">
//                                             <li><strong>Date:</strong> {modalData.Date}</li>
//                                             <li><strong>Start Time:</strong> {modalData.Start_Time}</li>
//                                             <li><strong>End Time:</strong> {modalData.End_Time}</li>
//                                             <li><strong>Payment Mode:</strong> {modalData.PaymentMode}</li>
//                                             <li><strong>Table No:</strong> {modalData.Table_No}</li>
//                                             <li><strong>Total Count:</strong> {modalData.TotalCount}</li>
//                                             <li><strong>Type:</strong> {modalData.Type}</li>
//                                         </ul>
//                                     </div>
//                                 </div>

//                                 {/* Item Details (Table) */}
//                                 <table className="custom-item-table">
//                                     <thead>
//                                         <tr>
//                                             <th>Item Type</th>
//                                             <th>Item Name</th>
//                                             <th>Quantity</th>
//                                             <th>Rate</th>
//                                             <th>Total</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {modalData.details.map((detail, index) => (
//                                             <tr key={index}>
//                                                 <td>{detail.ItemType}</td>
//                                                 <td>{detail.itemName}</td>
//                                                 <td>{detail.Quantity}</td>
//                                                 <td>{detail.itemrate}</td>
//                                                 <td>{detail.total}</td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>

//                                 {/* Employee, Service Charge, VAT below the item details table */}
//                                 <div className="custom-charges">
//                                     <ul className="custom-charges-list">
//                                         <li><strong>Employee:</strong> {modalData.employee}</li>
//                                         <li><strong>Service Charge:</strong> {modalData.serviceCharge}</li>
//                                         <li><strong>VAT:</strong> {modalData.vat}</li>
//                                     </ul>
//                                 </div>
//                             </div>
//                             <div className="custom-modal-footer">
//                                 <div className="custom-footer-content">
//                                     <strong>Total:</strong>
//                                     <strong>{modalData.total}</strong>
//                                 </div>
//                                 <button type="button" className="custom-footer-close-btn" onClick={closeModal}>Close</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}


//         </div>
//     )
// }

// export default ComplimentaryTable;











import React, { useRef, useState } from 'react';
import DateFormat from './DateFormat';
import axios from 'axios';
import * as XLSX from "xlsx";
import { FaDownload, FaRegFileAlt } from "react-icons/fa";
import { FaCircleExclamation, FaCircleNotch } from "react-icons/fa6";
import BillDetail from '../Modal/BillDetail';
import { formatSalesValue } from '../../utils/formatUtils';
import { FiAlertCircle } from 'react-icons/fi';

const ComplimentaryTable = ({
    complimentary,
    complimentaryTotal,
    start,
    end,
    token,
    loading,
    selectedOutlet,
    error,
    startDate,
    endDate,
}) => {
    const tableRef = useRef(null);

    const [showModal, setShowModal] = useState(false);
    const [billData, setBillData] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    const [modalError, setModalError] = useState(null);
    const [activeBillId, setActiveBillId] = useState(null);

    const handleBillID = async (idtblorderHistory) => {
        setActiveBillId(idtblorderHistory);
        setModalLoading(true);
        setModalError(null);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/billinfo_byid`,
                { token, bill_id: idtblorderHistory }
            );

            if (response?.data) {
                setBillData(response.data);
                setShowModal(true);
            }
        } catch (error) {
            console.error('Bill fetch error:', error);
            setModalError('Failed to load bill details. Please try again.');
        } finally {
            setModalLoading(false);
            setActiveBillId(null);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setBillData([]);
        setModalError(null);
    };

    const handleExport = () => {
        const rows = [
            ["Complimentary Report"],
            [`Date Range: ${startDate} - ${endDate}`],
            [],
            ["Order ID", "Date", "Customer", "Mode", "Total"],
        ];

        complimentary.forEach((item) => {
            rows.push([
                item.idtblorderHistory,
                item.Date,
                item.Customer,
                item.Mode,
                item.Total,
            ]);
        });

        rows.push([
            "",
            "",
            "",
            "Total Complimentary",
            complimentaryTotal,
        ]);

        const ws = XLSX.utils.aoa_to_sheet(rows);

        ws["!cols"] = [
            { wch: 15 }, // Order ID
            { wch: 18 }, // Date
            { wch: 25 }, // Customer
            { wch: 15 }, // Mode
            { wch: 15 }, // Total
        ];

        ws["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
        ];

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            "Complimentary"
        );

        XLSX.writeFile(
            wb,
            `complimentary_${new Date()
                .toISOString()
                .split("T")[0]}.xlsx`
        );
    };

    if (error) {
        return (
            <div className="flex items-start justify-center gap-3 rounded-lg border border-red-200 bg-red-50 p-4 text-red-700 shadow-sm font-semibold">
                <FiAlertCircle className="h-6 w-6 flex-shrink-0" />

                <div>{error}</div>
            </div>
        )
    }

    return (
        <div className="flex flex-col max-h-full bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            {/* Table Header */}
            <div className="flex items-center justify-between px-4 py-1.5 border-b border-gray-100 bg-gray-50">
                <div className="text-[13px] font-semibold text-gray-700 tracking-wide uppercase">
                    Complimetary List
                </div>
                <button
                    onClick={handleExport}
                    className="flex items-center gap-1.5 px-2.5 py-[5px] text-xs font-medium text-emerald-700 bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 rounded transition-colors"
                >
                    <FaDownload size={12} />
                    Export
                </button>
            </div>

            {/* Inline fetch error */}
            {modalError && (
                <div className="mx-4 mt-3 px-3 py-2 bg-red-50 border border-red-200 rounded text-xs text-red-700 flex items-center gap-2">
                    <FaCircleExclamation
                        size={28}
                        className="shrink-0"
                    />
                    {modalError}
                </div>
            )}

            {/* Table */}
            <div className="overflow-auto flex-1 tiny-scrollbar max-h-[600px]">
                {loading ? (
                    <div className="flex flex-col items-center justify-center h-48 gap-3 text-gray-400">
                        <FaCircleNotch
                            size={28}
                            className="animate-spin text-blue-400"
                        />
                        <span className="text-sm">Loading complimentary...</span>
                    </div>
                ) : complimentary.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-48 gap-2 text-gray-400">
                        <FaRegFileAlt
                            size={40}
                            className="opacity-40"
                        />
                        <p className="text-sm">No complimentary records</p>
                    </div>
                ) : (
                    <table className="w-full text-sm border-collapse text-center" ref={tableRef}>
                        <thead>
                            <tr className="bg-blue-50 text-blue-800 text-xs uppercase tracking-wide sticky top-0 z-10">
                                <th className="px-1.5 py-2.5 font-semibold border-b border-blue-100">Order ID</th>
                                <th className="px-1.5 py-2.5 font-semibold border-b border-blue-100">Date</th>
                                <th className="px-1.5 py-2.5 font-semibold border-b border-blue-100">Customer</th>
                                <th className="px-1.5 py-2.5 font-semibold border-b border-blue-100">Mode</th>
                                <th className="px-1.5 py-2.5 font-semibold border-b border-blue-100">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {complimentary.map((item) => (
                                <tr
                                    key={item.idtblorderHistory}
                                    className="hover:bg-blue-50/40 transition-colors border-b border-gray-100 last:border-0"
                                >
                                    <td className="px-1.5 py-2 flex justify-center">
                                        <button
                                            onClick={() => handleBillID(item.idtblorderHistory)}
                                            disabled={modalLoading}
                                            className="text-blue-600 hover:text-blue-800 hover:underline font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-1"
                                        >
                                            {modalLoading && activeBillId === item.idtblorderHistory ? (
                                                <FaCircleNotch
                                                    size={14}
                                                    className="animate-spin"
                                                />
                                            ) : item.idtblorderHistory}
                                        </button>
                                    </td>
                                    <td className="px-1.5 py-2 text-gray-500 whitespace-nowrap">
                                        <DateFormat date={item.Date} />
                                    </td>
                                    <td className="px-1.5 py-2 text-gray-700">{item.Customer}</td>
                                    <td className="px-1.5 py-2 text-gray-500">{item.Mode}</td>
                                    <td className="px-1.5 py-2 font-medium text-gray-800">{formatSalesValue(item.Total)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="bg-gray-50 border-t-2 border-gray-200 font-semibold text-gray-800 text-sm">
                                <td className="px-1.5 py-2 text-right" colSpan={4}>
                                    <span className="text-sm font-semibold mr-2">Total Complimentary:</span>
                                </td>
                                <td className="px-1.5 py-2">{formatSalesValue(complimentaryTotal)}</td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </div>

            <BillDetail
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                data={billData}
                selected={selectedOutlet}
                billID={activeBillId}
            />
        </div>
    );
};

export default ComplimentaryTable;